import { Link } from 'react-router-dom'
import DisplayShopName from '../common/DisplayShopName'

export const WholesalerCard = ({ wholesaler }) => {
  return (
    <Link to={`/wholesellers/${wholesaler.shopSlug}/products`}>
      <div className="relative rounded-md overflow-hidden mb-2 bg-neutral-200 flex items-center justify-center w-32 h-28 shrink-0 mx-auto">
        <img
          src={wholesaler.shopPicture}
          alt={wholesaler.shopName}
          className="w-full h-full object-contain  object-center transition-transform duration-200 hover:scale-105"
          loading="lazy"
        />
      </div>
      <p className="text-center  text-gray-900 truncate">
        <DisplayShopName
          shop={{
            name: wholesaler.shopName,
            isPremium: wholesaler.isPremium,
            isVerified: wholesaler.isApproved,
          }}
        />
      </p>
    </Link>
  )
}
